let colorList = ['#f36c6c', '#e6cf4e', '#20d180', '#0093ff'];

export default {
    optionMap: {
        title: {
            text: '地区统计分析',
            textStyle: {
                color: "#f7f7b8",
                fontSize: 16,
            },
            textAlign: 'center',
            left: "middle",
            top: 20,
            z: 0,
            right: "auto",
        },

        tooltip: {
            position: 'right',
            axisPointer: {
                type: 'shadow'
            }
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    pixelRatio: 2,
                    backgroundColor: "#1D2A48"
                },
            },
            iconStyle: {
                borderColor: '#f7f7b6'
            },
            right: 70,
            top:20,
        },
        geo: {
            map: 'china',
            label: {
                position: "insideTopRight",
                show: true,
                color: '#f7f7b6',
                fontSize: 16,
                textBorderColor: "443B60",
                emphasis: {
                    color: '#f7f7b6',
                    show: false
                }
            },
            roam: false,//是否允许缩放
            scaleLimit: {
                min: 0,
                max: 3
            }, //缩放级别

            zoom: 1.0, //默认显示级别
            itemStyle: {
                normal: {
                    borderColor: '#1B2947',
                    borderWidth: 1,
                    color: "#ffffff",
                    shadowColor: 'rgba(255, 255, 255, 0)',
                    shadowOffsetX: -2,
                    shadowOffsetY: 2,
                    shadowBlur: 10
                },
                emphasis: {
                    label: {
                        color: '#79ADDB'
                    },
                    color: "#7e5077",
                    borderWidth: 0,
                }
            },
            tooltip: {
                show: true
            }
        },
        series: [
            {
                // name: "项目总数",
                type: 'map',
                map: 'china',
                geoIndex: 0,
                z: 0,
                // left: 100,
                // top: 0,
                label: {
                    show: false,
                    color: "red",
                    fontSize: 16
                },
                zoom: 0.9,
                data: [],
            },
        ],
        visualMap: [{
            type: "piecewise",
            show: true,
            seriesIndex: 0,
            bottom: 100,
            left: 100,
            inRange: {
                symbol: 'rect',
                color: ['#ffffff', '#59446c']
            },
            textStyle: {
                color: "#f7f7b6",
            },
            pieces: [
                {min: 150},
                {min: 100, max: 149},
                {min: 50, max: 99},
                {min: 20, max: 49},
                {min: 10, max: 19},
                {min: 1, max: 9},
                {min: 0, max: 0},
            ]
        }],
        animationEasing: 'elasticOut',
    },
    // 项目统计分析：迁移地图
    optionMigrateMap: {
        title: {
            textStyle: {
                color: "#f7f7b6",
                fontSize: 16,
            },
            left: 50,
            top: 10,
            z: 0,
            right: "auto",
        },
        tooltip: {
            trigger: 'item',
            formatter: function (params) {
                if (params.seriesType == "scatter") {
                    return "<br>" + params.seriesName + " ---> " + params.data.name + "<br />项目数量：" + params.data.value[2];
                } else if (params.seriesType == "lines") {
                    return "<br>" + params.data.fromName + " ---> " + params.data.toName + "<br />项目数量：" + params.data.value;
                } else {
                    return params.name;
                }
            }
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    pixelRatio: 2,
                    backgroundColor: "#1D2A48"
                },

            },
            iconStyle: {
                borderColor: '#f7f7b6'
            },
            right: 70,
        },
        geo: {
            map: 'china',
            label: {
                position: "insideTopRight",
                show: true,
                color: '#f7f7b6',
                fontSize: 14,
                textBorderColor: "443B60",
                emphasis: {
                    color: '#f7f7b6',
                    show: false
                }
            },
            roam: true,//是否允许缩放
            scaleLimit: {
                min: 0,
                max: 3
            }, //缩放级别
            zoom: 1.2, //默认显示级别
            itemStyle: {
                normal: {
                    borderColor: '#52dbf5',
                    areaColor: '#514168',
                },
                emphasis: {
                    color: "#112246"
                }
            },
            tooltip: {
                show: true
            }
        },
        visualMap: {
            calculable: true,
            color: ['#00ff78', '#ff971b', '#acff43', '#ff73b7', '#ffff46', '#27bbfe'],
            show: false
        },
        animationEasing: 'elasticOut',
        series: [
            {
                type: 'map',
                map: 'china',
                geoIndex: 0,
                z: 0,
            },
            {
                type: 'lines',
                zlevel: 3,
                symbol: ['none', 'circle'],
                effect: {
                    show: true,
                    period: 3, //箭头指向速度，值越小速度越快
                    trailLength: 0.25, //特效尾迹长度[0,1]值越大，尾迹越长重
                    symbolSize: 8, //图标大小
                },
                lineStyle: {
                    normal: {
                        opacity: 1,
                        curveness: 0.3, //曲线的弯曲程度
                        color: 'blue'

                    }

                },
            },
            {
                type: 'effectScatter',
                coordinateSystem: 'geo',
                zlevel: 2,
                rippleEffect: {
                    brushType: 'stroke'
                },
                label: {
                    normal: {
                        position: 'right',
                        formatter: '{b}',
                    }
                },
                symbolSize: function (val) {
                    console.log(val);
                    return (val[2] / val[3]) * 35;
                },
                itemStyle: {
                    normal: {
                        //                fontSize: 80,
                    }
                },
            },
            {
                type: 'effectScatter',
                coordinateSystem: 'geo',
                zlevel: 4,
                symbolSize: 24,
                label: {

                    show: true,
                    position: 'right',
                    formatter: '{b}',
                    fontSize: 20,
                    color: 'red',
                    textBorderColor: "#2ce6c4",
                    fontWeight: "bolder"

                },
                itemStyle: {
                    normal: {
                        color: 'red'
                    }
                },
                rippleEffect: {
                    scale: 3,
                    brushType: 'stroke'
                },
            }]
    },
    // 项目统计分析：地区条行图分析
    optionBar: {
        title: {
            text: '各省项目排行',
            textStyle: {
                color: "#f7f7b6",
                fontSize: 16,
            },
            top:20
        },
        color: ["#674b75", "#edebef"],
        grid: {
            bottom: 100,
            top: 60,
            left: -30,
            containLabel: true,

        },
        legend: {
            right: 100,
            // data: ['报告表', '报告书'],
            textStyle: {
                color: "#f7f7b6",
                fontSize: 14,
            },
            top:20
        },
        tooltip: {
            axisPointer: {
                type: 'shadow'
            }
        },
        toolbox: {
            feature: {
                magicType: {
                    type: ['stack', 'tiled']
                },
                saveAsImage: {
                    pixelRatio: 2,
                    backgroundColor: "#1D2A48"
                },

            },
            iconStyle: {
                borderColor: '#f7f7b6'
            },
            top: 18,
            right: 10,
        },
        xAxis: {
            type: 'value',
            splitLine: {
                show: false
            },
            axisLabel: {
                interval: 0,
                textStyle: {
                    color: '#f7f7b6',
                    align: 'left',
                    fontSize: 14,
                },
            }
        },
        yAxis: {
            type: 'category',
            inverse: true,
            axisLine: {
                show: true,
                lineStyle: {
                    color: "black",
                }
            },

            axisTick: {
                show: true,
                lineStyle: {
                    color: '#ddd'
                }
            },
            axisLabel: {
                // interval: 0,
                margin:90,
                textStyle: {
                    color: '#f7f7b6',
                    align: 'left',
                    fontSize: 16,

                },
                rich: {
                    a: {
                        color: '#ffffff',
                        backgroundColor: '#f0515e',
                        width: 20,
                        height: 20,
                        align: 'center',
                        // borderRadius: 2,
                    },
                    b: {
                        color: '#ffffff',
                        backgroundColor: '#24a5cd',
                        width: 20,
                        height: 20,
                        align: 'center',
                    }
                },
                formatter: function (params) {
                    if (parseInt(params.slice(0, 2)) < 5) {
                        return [
                            '{a|' + (parseInt(params.slice(0, 2)) + 1) + '}' + '  ' + params.slice(2)
                        ].join('\n')
                    } else {
                        return [
                            '{b|' + (parseInt(params.slice(0, 2)) + 1) + '}' + '  ' + params.slice(2)
                        ].join('\n')
                    }
                }
            },
        },
        dataZoom: [
            {
                start: 0,
                end: 50,
                yAxisIndex: 0,
                showDetail: false
            },
        ],
        series: [
            {
                // name: '报告表',
                type: 'bar',
                roam: false,
                visualMap: false,
                barMaxWidth: 30,
                stack: '总量',
                label: {
                    normal: {
                        show: true,
                        fontSize: 14,
                        color: "#f7f7b6",
                        textBorderColor: '#333',
                        textBorderWidth: 2
                    }
                },
                animationDelay: function (idx) {
                    return idx * 10
                }
            },
            {
                // name: '报告书',
                type: 'bar',
                show: false,
                barMaxWidth: 30,
                stack: '总量',
                label: {
                    normal: {
                        position: 'right',
                        show: true,
                        fontSize: 14,
                        color: "#f7f7b6",
                        textBorderColor: '#333',
                        textBorderWidth: 2
                    }
                },
                animationDelay: function (idx) {
                    return idx * 10 + 100

                }
            },
            {
                type: 'pie',
                z: 3,
                center: ['65%', '70%'],
                radius: '40%',
                selectedOffset: 20,
                label: {
                    formatter: '{c|数量：{c}}\n{per|百分比:{d}%} ',
                    position: "inside",
                    lineHeight: 20,
                    rich: {
                        c: {
                            color: '#f7f7b6',
                            align: 'center',
                            fontSize: 14,
                            textBorderColor: '#333',
                        },
                        per: {
                            color: '#f7f7b6',
                            align: 'center',
                            fontSize: 14,
                            textBorderColor: '#333',
                        }
                    }
                },
            },
        ],
        animationEasing: 'elasticOut',
        // animationDelayUpdate: 1000,
    },
    // 项目统计分析：行业分析
    optionIndustryBar: {
        title: {
            text: '行业统计分析',
            textAlign: 'center',
            textStyle: {
                color: "#f7f7b6",
                fontSize: 16,
            },
            left: "middle",
            top: 0,
            right: "auto",
        },
        color: ["#62f5a5", "#52dbf5", "#F7596A", "#f5ddaf", "#edebef"],
        tooltip: {
            formatter: '{b}<br />项目数：{c}<br />点击加载详细行业分布'
        },
        toolbox: {
            feature: {

                saveAsImage: {
                    pixelRatio: 2,
                    backgroundColor: "#1D2A48"
                },

            },
            iconStyle: {
                borderColor: '#f7f7b6'
            },
            top: -5,
            right: 50,
        },
        legend: {
            right: 200,
            top: 0,
            height: 50,
            data: ['全部', '报告书', '报告表'],
            selectedMode: 'single',
            selected: {
                '全部': true,
                '报告书': false,
                '报告表': false,
            },
            textStyle: {
                color: "#f7f7b6",
                fontSize: 14,
            },
        },
        calculable: true,
        grid: {
            top: 90,
            bottom: 140,
            left: 100,
            right: 100,
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow',
                    label: {
                        show: true,
                        formatter: function (params) {
                            return params.value.replace('\n', '');
                        }
                    }
                }
            }
        },
        xAxis: [{
            type: 'category',
            axisLabel: {
                interval: 0,
                textStyle: {
                    color: '#f7f7b6',
                    align: 'center',
                    fontSize: 14,
                },
                formatter: function (params) {
                    if (params.length > 5 && params.indexOf('\n\n') !== -1) {
                        return params.slice(0, 7)
                    } else if (params.length > 5) {
                        return params.slice(0, 5)
                    } else {
                        return params
                    }
                }
            },
            splitLine: {show: false},
        }],
        yAxis: [{
            type: 'value',
            name: '项目数',
            minInterval: 1,
            nameTextStyle: {
                color: "#f7f7b6",
                fontSize: 14
            },
            color: '#f7f7b6',
            splitLine: {
                show: false
            },
            axisLabel: {
                interval: 0,
                margin: 60,
                textStyle: {
                    color: '#f7f7b6',
                    align: 'left',
                    fontSize: 14,

                },
            }
        }],
        dataZoom: [{
            show: true,
            type: 'slider',
            showDetail: false,
            bottom: 50,
            start: 0,
            end: 60,
            minSpan: 8,
            xAxisIndex: 0,
            dataBackground: {
                lineStyle: {
                    color: '#95BC2F'
                },
                areaStyle: {
                    color: '#95BC2F',
                    opacity: 1,
                }
            },
        },],
        series: [
            {
                name: '全部',
                type: 'bar',
                animationDelay: function (idx) {
                    return idx * 100
                },
                label: {
                    normal: {
                        show: true,
                        fontSize: 14,
                        color: "#f7f7b6",
                        textBorderColor: '#333',
                        textBorderWidth: 2
                    }
                },
                barMaxWidth: 30,
                markLine: {
                    silent: false,
                    precision: 2,
                    label: {
                        show: true,
                        position: "middle",
                        color: "#f7f7b6",
                        margin: 8,
                        fontSize: 16,
                        textBorderColor: "f7f7b6",
                        formatter: function (params) {
                            return params.value + '\n' + params.name
                        }
                    },
                    lineStyle: {
                        width: 4,
                        color: "#654A73"
                    },
                    data: [
                        {
                            name: "行业均值",
                        }
                    ]
                },
            },
            {
                name: '报告表',
                type: 'bar',
                animationDelay: function (idx) {
                    return idx * 100
                },
                label: {
                    normal: {
                        show: true,
                        fontSize: 14,
                        color: "#f7f7b6",
                        textBorderColor: '#333',
                        textBorderWidth: 2
                    }
                },
                barMaxWidth: 30,
                markLine: {
                    silent: false,
                    precision: 2,
                    label: {
                        show: true,
                        position: "middle",
                        color: "#f7f7b6",
                        margin: 8,
                        fontSize: 16,
                        textBorderColor: "f7f7b6",
                        formatter: function (params) {
                            return params.value + '\n' + params.name
                        }
                    },
                    lineStyle: {
                        width: 4,
                        color: "#654A73"
                    },
                    data: [
                        {
                            name: "行业均值",
                        }
                    ]
                },
            },
            {
                name: '报告书',
                type: 'bar',
                animationDelay: function (idx) {
                    return idx * 100
                },
                label: {
                    normal: {
                        show: true,
                        fontSize: 16,
                        color: "#f7f7b6",
                        textBorderColor: '#333',
                        textBorderWidth: 2
                    }
                },
                barMaxWidth: 30,
                markLine: {
                    silent: false,
                    precision: 2,
                    label: {
                        show: true,
                        position: "middle",
                        color: "#f7f7b6",
                        margin: 8,
                        fontSize: 18,
                        textBorderColor: "f7f7b6",
                        formatter: function (params) {
                            return params.value + '\n' + params.name
                        }
                    },
                    lineStyle: {
                        width: 4,
                        color: "#654A73"
                    },
                    data: [
                        {
                            name: "行业均值",
                        }
                    ]
                },
            },
            {
                name: '行业分布',
                type: 'pie',
                radius: [100, 200],
                center: ['75%', '35%'],
                z: 100,
                animationDelay: function (idx) {
                    return idx * 30
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                label: {
                    fontSize: 16,
                    formatter: function (params) {
                        if (params.name.length > 10) {
                            return (params.name.slice(0, 10))
                        } else {
                            return params.name
                        }
                    }
                },
            },
        ]
    },

    // 项目统计分析：趋势分析
    optionTrendsLine: {
        title: {
            text: '时间趋势分析',
            textAlign: 'center',
            textStyle: {
                color: "#f7f7b8",
                fontSize: 16,
                // fontWeight:"bord",
                // textBorderColor: "#ddd"
            },
            left: "middle",
            top: 20,

            // right: "auto",
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross'
            }
        },
        toolbox: {
            feature: {
                magicType: {
                    type: ['line', 'bar']
                },
                saveAsImage: {
                    pixelRatio: 2,
                    backgroundColor: "#1D2A48"
                },


            },
            iconStyle: {
                borderColor: '#f7f7b6'
            },
            top: 35,
            right: 50,
        },
        // color:["#3F395D", "#E17693", "#D93DE1"],
        legend: {
            right: 200,
            top: 38,
            height: 50,
            data: ['全部', '报告书', '报告表'],
            selectedMode: 'single',
            selected: {
                '全部': true,
                '报告书': false,
                '报告表': false,
            },
            textStyle: {
                color: "#f7f7b6",
                fontSize: 14,
            },
        },
        dataZoom: [{
            type: 'slider',
            show: true,
            height: 30,
            // left: '8%',
            // right: '8%',
            bottom: '100',
            showDetail: false,
            start: 0,
            end: 100,
            textStyle: {
                color: '#f7f7b6',
                fontSize: 11,
            },
        }, {
            type: 'inside'
        }],
        grid: {
            top: 100,
            bottom: 150,
            left: 20,
            right: 50,
            containLabel: true
        },
        xAxis: {
            type: 'category',
            name: '时间',
            nameTextStyle: {
                color: "#f7f7b6",
                fontSize: 16
            },
            axisLabel: {
                // interval: 0,
                textStyle: {
                    color: '#f7f7b6',
                    align: 'left',
                    fontSize: 16,
                },
            }
        },
        yAxis: {
            type: 'value',
            name: '项目数',
            minInterval: 1,
            nameTextStyle: {
                color: "#f7f7b6",
                fontSize: 16
            },
            color: '#f7f7b6',
            splitLine: {
                show: false
            },
            axisLabel: {
                interval: 0,
                margin: 60,
                textStyle: {
                    color: '#f7f7b6',
                    align: 'left',
                    fontSize: 16,

                },
            }
        },
        series: [{
            name: '全部',
            type: 'line',
            symbolSize: 10,
            itemStyle: {
                color: "#2ee6db",
            },
        }, {
            name: '报告书',
            type: 'line',
            symbolSize: 10,
            itemStyle: {
                color: "#2ee6db",
            },
        }, {
            name: '报告表',
            type: 'line',
            symbolSize: 10,
            itemStyle: {
                color: "#2ee6db",
            },
        }]
    },
    optionTrendsBar: {
        tooltip: {},
        toolbox: {
            feature: {
                saveAsImage: {
                    pixelRatio: 2,
                    backgroundColor: "#1D2A48"
                },

            },
            top: 8,
            right: 50,
            iconStyle: {
                borderColor: '#f7f7b6'
            },
        },
        // color:["#3F395D", "#DE6C90"],
        legend: {
            top: 10,
            height: 50,
            show: true,
            data: ['报告表', '报告书'],
            textStyle: {
                color: "#f7f7b6",
                fontSize: 14,
            },
        },

        angleAxis: {
            type: 'category',
            axisLabel: {
                color: "#f7f7b6",
                fontSize: 16,
            }
        },
        radiusAxis: {
            axisLabel: {
                color: "#f7f7b6",
                fontSize: 16,
            },
            axisTick: {
                color: "#f7f7b6"
            }
        },
        polar: {
            center: ['49%', '45%']
        },
        series: [{
            type: 'bar',
            coordinateSystem: 'polar',
            name: '报告表',
            stack: '总量'
        }, {
            type: 'bar',
            coordinateSystem: 'polar',
            name: '报告书',
            stack: '总量'
        }],
    },

    // 编制单位、主持人平均值
    optionAvgBar: {
        title: {
            text: "各省编制单位平均业绩情况",
            textStyle: {
                color: "#f7f7b6",
                fontSize: 16,
            },
            textAlign: 'center',
            left: "middle",
            top: 0,
            right: "auto",
        },
        tooltip: {},
        toolbox: {
            feature: {
                magicType: {
                    type: ['tiled',]
                },
                saveAsImage: {
                    pixelRatio: 2,
                    backgroundColor: "#1D2A48"
                },

            },
            iconStyle: {
                borderColor: '#f7f7b6'
            },
            right: 100,
            top: 55,
        },

        grid: {
            top: 120,
            bottom: 160,
            left: 140,
            right: 140,
        },
        legend: {
            top: 80,
            right: 200,
            height: 50,
            data: ['总量', '报告表', '报告书'],
            // selectedMode: 'single',
            // selected: {
            //     '全部': true,
            //     '报告书': false,
            //     '报告表': false,
            // },
            textStyle: {
                color: "#f7f7b6",
                fontSize: 14,
            },
        },
        dataZoom: [{
            show: true,
            height: 30,
            xAxisIndex: [0],
            bottom: 100,

            "start": 0,
            "end": 60,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            // handleSize: '110%',
            handleStyle: {
                color: "#f7f7b6",
            },
            // textStyle: {
            //     color: "rgba(204,187,225,0.5)",
            // },
            // fillerColor: "rgba(67,55,160,0.4)",
            // borderColor: "rgba(204,187,225,0.5)",

        }, {
            type: "inside",
            show: true,
            height: 15,
            start: 1,
            end: 35
        }],
        xAxis: {
            type: 'category',
            axisLabel: {
                interval: 0,
                textStyle: {
                    color: '#f7f7b6',
                    align: 'center',
                    fontSize: 14,

                },
            }
        },

        yAxis: {
            type: 'value',
            name: '业绩均值',
            nameTextStyle: {
                color: '#f7f7b6',
                align: 'right',
                fontSize: 16,
            },
            minInterval: 1,
            splitLine: {show: false},
            axisLabel: {
                interval: 0,
                textStyle: {
                    color: '#f7f7b6',
                    align: 'center',
                    fontSize: 12,
                },
            },
        },

        series: [
            // {
            //     name:"报告表",
            //
            //     type: 'bar',
            //     animationDelay: function (idx) {
            //         return idx * 100
            //     },
            //     barMaxWidth: 30,
            //     markPoint: {
            //         data: [
            //             {type: 'max', name: '最大值'},
            //             {type: 'min', name: '最小值'}
            //         ]
            //     },
            //     markLine: {
            //         data: [
            //             {type: 'average', name: '平均值'}
            //         ],
            //         lineStyle: {
            //             width: 2
            //         },
            //         label: {
            //             fontSize: 14,
            //             color: '#f7f7b6'
            //         }
            //     },
            //     showBackground: true,
            //     itemStyle: {
            //         normal: {
            //             color: '#e63b0c'
            //         },
            //     }
            // },
            {
                name: "报告表",
                type: 'bar',
                animationDelay: function (idx) {
                    return idx * 100
                },
                stack: '总量',
                barMaxWidth: 30,
                // markPoint: {
                //     data: [
                //         {type: 'max', name: '最大值'},
                //         {type: 'min', name: '最小值'}
                //     ]
                // },
                label: {
                    normal: {
                        show: true,
                        fontSize: 16,
                        color: "#f7f7b6",
                        textBorderColor: '#333',
                        textBorderWidth: 2
                    }
                },
                markLine: {
                    data: [
                        {type: 'average', name: '平均值'}
                    ],
                    lineStyle: {
                        width: 2
                    },
                    label: {
                        fontSize: 14,
                        color: '#f7f7b6'

                    }
                },
                itemStyle: {
                    normal: {
                        color: '#fe2d32'
                    },
                },
                showBackground: true,
            },
            {
                name: '报告书',
                type: 'bar',
                animationDelay: function (idx) {
                    return idx * 100
                },
                label: {
                    normal: {
                        show: true,
                        fontSize: 16,
                        color: "#f7f7b6",
                        textBorderColor: '#333',
                        textBorderWidth: 2
                    }
                },
                stack: '总量',
                barMaxWidth: 30,
                // markPoint: {
                //     data: [
                //         {type: 'max', name: '最大值'},
                //         {type: 'min', name: '最小值'}
                //     ]
                // },
                markLine: {
                    // data: [
                    //
                    //     {type: 'average', name: '平均值'}
                    // ],
                    lineStyle: {
                        width: 2
                    },
                    label: {
                        fontSize: 14,
                        color: '#f7f7b6'

                    }

                },
                itemStyle: {
                    normal: {
                        color: '#2ce6c4'
                    },
                },
                showBackground: true,
            },
            {
                name: '报告书',
                type: 'line',  // 平均值
                data: [],
                lineStyle: {
                    opacity: 0
                },
                markLine: {

                    data: [

                        {type: 'average', name: '平均值'}
                    ],
                    lineStyle: {
                        width: 2
                    },
                    label: {
                        fontSize: 14,
                        color: '#f7f7b6'
                    }

                },
                itemStyle: {
                    normal: {
                        color: '#2ce6c4'
                    },
                },
            }

        ]
    },
    // 编制单位、主持人排行榜
    optionRankBar: {
        title: {
            text: '全国业绩排行榜（前50名）',
            textAlign: 'center',
            textStyle: {
                color: "#f7f7b6",
                fontSize: 16,
            },
            left: "middle",
            top: 20,
            z: 0,
            right: "auto",
        },
        color: ["#f5ddaf", "#edebef"],
        tooltip: {
            axisPointer: {
                type: 'shadow'
            },
            formatter: function (params) {
                return params.name.slice(2) + '<br/>' + params.seriesName + '：' + params.value
            }
        },
        legend: {
            top: 80,
            right: 150,
            data: ['报告表', '报告书'],
            selected: {'报告表': true, '报告书': false},
            selectedMode: 'single',
            textStyle: {
                color: "#f7f7b6",
                fontSize: 14,
            },
        },
        grid: {
            left: 450,
            top: 120,
            bottom: 120,
        },
        toolbox: {
            right: 60,
            top: 55,
            show: true,
            feature: {
                saveAsImage: {
                    pixelRatio: 2,
                    backgroundColor: "#1D2A48"
                },

            },
            iconStyle: {
                borderColor: '#f7f7b6',

            },

        },
        xAxis: {
            type: 'value',
            splitLine: {
                show: false
            },
            axisLabel: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLine: {
                show: false
            }

        },
        yAxis: {
            type: 'category',
            inverse: true,
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisPointer: {
                label: {
                    show: true,
                    margin: 30
                }
            },
            axisLabel: {
                margin: 300,
                fontSize: 14,
                align: 'left',
                color: '#f7f7b6',
                rich: {
                    a1: {
                        color: '#fff',
                        backgroundColor: colorList[0],
                        width: 30,
                        height: 30,
                        align: 'center',
                        borderRadius: 2
                    },
                    a2: {
                        color: '#fff',
                        backgroundColor: colorList[1],
                        width: 30,
                        height: 30,
                        align: 'center',
                        borderRadius: 2
                    },
                    a3: {
                        color: '#fff',
                        backgroundColor: colorList[2],
                        width: 30,
                        height: 30,
                        align: 'center',
                        borderRadius: 2
                    },
                    b: {
                        color: '#fff',
                        backgroundColor: colorList[3],
                        width: 30,
                        height: 30,
                        align: 'center',
                        borderRadius: 2
                    }
                },
                formatter: function (params) {
                    let index = parseInt(params.slice(0, 2)) + 1
                    if (index - 1 < 3) {
                        return [
                            '{a' + index + '|' + index + '}' + '  ' + params.slice(2)
                        ].join('\n')
                    } else {
                        return [
                            '{b|' + index + '}' + '  ' + params.slice(2)
                        ].join('\n')
                    }
                }
            }
        },
        dataZoom: [
            {
                show: true,
                zoomLock: true,
                type: 'slider',//数据滑块
                yAxisIndex: 0,
                right: 100,
                showDetail: false,
                dataBackground: {
                    lineStyle: {
                        color: '#95BC2F'
                    },
                    areaStyle: {
                        color: '#95BC2F',
                        opacity: 1,
                    }
                },
            },
        ],
        series: [
            {
                z: 2,
                name: '报告表',
                type: 'bar',
                barMaxWidth: '25px',
                label: {
                    normal: {
                        show: true,
                        fontSize: 16,
                        color: "#f7f7b6",
                        textBorderColor: '#333',
                        textBorderWidth: 2
                    },
                    right: 'center',
                    show: true,
                    position: 'right',
                    color: '#f7f7b6',
                    fontSize: 14,
                    offset: [10, 0],
                    formatter: function (params) {
                        if ((params.value / params.data.avg - 1) <= 0) {
                            return '低于' + params.data.area + '均值'
                        } else {
                            return '超过' + params.data.area + '均值' + ((params.value / params.data.avg - 1) * 100).toFixed(0) + '%'
                        }
                    }
                }
            },
            {
                z: 2,
                name: '报告书',
                type: 'bar',
                barMaxWidth: '25px',
                label: {
                    normal: {
                        show: true,
                        fontSize: 16,
                        color: "#f7f7b6",
                        textBorderColor: '#333',
                        textBorderWidth: 2
                    },
                    right: 'center',
                    show: true,
                    position: 'right',
                    color: '#f7f7b6',
                    fontSize: 14,
                    offset: [10, 0],
                    formatter: function (params) {
                        if ((params.value / params.data.avg - 1) <= 0) {
                            return '低于' + params.data.area + '均值'
                        } else {
                            return '超过' + params.data.area + '均值' + ((params.value / params.data.avg - 1) * 100).toFixed(0) + '%'
                        }
                    }
                }
            },
        ]
    },
    setPieces: function (data) {
        let pieces = [
            {min: 150},
            {min: 100, max: 149},
            {min: 50, max: 99},
            {min: 20, max: 49},
            {min: 10, max: 19},
            {min: 1, max: 9},
            {min: 0, max: 0},
        ];
        if (data[0].value > 0 && data[0].value < 50) {
            pieces = [
                {min: 50},
                {min: 40, max: 49},
                {min: 30, max: 39},
                {min: 20, max: 29},
                {min: 10, max: 19},
                {min: 1, max: 9},
                {min: 0, max: 0},
            ]
        } else if (data[0].value > 200 && data[0].value < 2000) {
            pieces = [
                {min: 500},
                {min: 300, max: 499},
                {min: 200, max: 299},
                {min: 100, max: 199},
                {min: 40, max: 99},
                {min: 1, max: 39},
                {min: 0, max: 0},
            ]
        } else if (data[0].value > 1999 && data[0].value < 5000) {
            pieces = [
                {min: 2000},
                {min: 1000, max: 1999},
                {min: 500, max: 999},
                {min: 200, max: 499},
                {min: 50, max: 199},
                {min: 1, max: 49},
                {min: 0, max: 0},
            ]
        } else if (data[0].value > 4999 && data[0].value < 20000) {
            pieces = [
                {min: 10000},
                {min: 5000, max: 9999},
                {min: 2000, max: 4999},
                {min: 1000, max: 1999},
                {min: 200, max: 999},
                {min: 1, max: 199},
                {min: 0, max: 0},
            ]
        } else if (data[0].value > 19999 && data[0].value < 50000) {
            pieces = [
                {min: 20000},
                {min: 15000, max: 19999},
                {min: 10000, max: 14999},
                {min: 5000, max: 9999},
                {min: 500, max: 4999},
                {min: 1, max: 499},
                {min: 0, max: 0},
            ]
        } else if (data[0].value > 49999) {
            pieces = [
                {min: 40000},
                {min: 20000, max: 39999},
                {min: 10000, max: 19999},
                {min: 5000, max: 9999},
                {min: 500, max: 4999},
                {min: 1, max: 499},
                {min: 0, max: 0},
            ]
        }
        return pieces
    },
    areaMap: {
        '阿坝藏族羌族自治州': '阿坝州', '甘孜藏族自治州': '甘孜州', '凉山彝族自治州': '凉山州', '克孜勒苏柯尔克孜自治州': '克孜勒',
        '巴音郭楞蒙古自治州': '巴音郭楞州', '伊犁哈萨克自治州': '伊犁州', '博尔塔拉蒙古自治州': '博尔塔拉州', '昌吉回族自治州': '昌吉州',
        '湘西土家族苗族自治州': '湘西州', '黔东南苗族侗族自治州': '黔东南州', '黔南布依族苗族自治州': '黔南州', '黔西南布依族苗族自治州': '黔西南州',
        '迪庆藏族自治州': '迪庆州', '怒江傈僳族自治州': '怒江州', '大理白族自治州': '大理州', '德宏傣族景颇族自治州': '德宏州',
        '楚雄彝族自治州': '楚雄州', '西双版纳傣族自治州': '西双版纳州', '红河哈尼族彝族自治州': '红河州', '文山壮族苗族自治州': '文山州',
        '延边朝鲜族自治州': '延边州', '恩施土家族苗族自治州': '恩施州', '临夏回族自治州': '临夏州', '甘南藏族自治州': '甘南州',
        '彭水苗族土家族自治县': '彭水县', '酉阳土家族苗族自治县': '酉阳县', '秀山土家族苗族自治县': '秀山县', '大兴安岭地区': '大兴安岭',
        '昌江彝族自治县': '昌江县', '白沙彝族自治县': '白沙县', '琼中黎族苗族自治县': '琼中县', '乐东黎族自治县': '乐东县',
        '保亭彝族苗族自治县': '保亭县', '陵水彝族自治县': '陵水县', '海西蒙古族藏族自治州': '海西州', '玉树藏族自治州': '玉树州',
        '果洛藏族自治州': '果洛州', '海南藏族自治州': '海南州', '海北藏族自治州': '海北州', '黄南藏族自治州': '黄南州'
    },
}